export default {
  domain: 'auth',
  routes: {
    login: {
      name: 'login',
      path: '/login',
      meta: {
        rule: 'isPublic',
      }
    },
    register: {
      name: 'register',
      path: '/register',
      meta: {
        rule: 'isPublic',
      }
    },
    forgotPassword: {
      name: 'forgot-password',
      path: '/esqueceu-senha',
      meta: {
        rule: 'isUser',
      }
    }
  },
};
